import { Injectable } from '@angular/core';
import { Role, ROLES, LoggedUser } from '../model/user.model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import {jwtDecode} from "jwt-decode";
import { LocalStorageService } from './local-storage.service';
import { SessionStorageService } from 'src/app/service/session-storage.service';
import { ROUTES } from '../route/routes';
import { CURRENT_USER, LANG } from '../constants/storage-elements';
import { MatDialog } from '@angular/material/dialog';
import { GenericConfirmationComponent } from '../components/dialog/generic-confirmation/generic-confirmation.component';
import { LANGUAGES } from '../constants/lang';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private api_prefix: string;

  constructor(
    private http: HttpClient,
    private router: Router,
    private lStorageService: LocalStorageService,
    private sStorageService: SessionStorageService,
    private dialog: MatDialog
  ) {
    this.api_prefix = environment.backEndUrl + '/login';
  }

  get displayName(): string | null {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return currentUser ? currentUser.displayName : null;
  }

  get inizialiNome(): string | null {
    let nameTemp = this.displayName!.toUpperCase().replaceAll("(EXTERNAL)","").trim().split(' ');
    nameTemp.map((n) => n[0]).join('');
    let name = [];
    name.push(nameTemp[0].substring(0, 1));
    name.push(nameTemp[nameTemp.length - 1].substring(0, 1));
    // for (let o of nameTemp) {
    //   name.push(o.substring(0, 1));
    // }
    return name.join('');
  }

  get displayNameImp(): string | null {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return currentUser && currentUser.displayNameImp
      ? currentUser.displayNameImp
      : null;
  }

  get token(): string | null {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return currentUser ? currentUser.idToken : null;
  }

  get isExpiredToken(): boolean {
    if (this.token) {
      let tokenDecoded: any = jwtDecode(this.token);
      let expMillis = tokenDecoded.exp * 1000;
      let nowMillis = new Date().getTime();
      return nowMillis > expMillis;
    }

    return true;
  }

  get uuidPassenger(): string | null {
    let currentUser: LoggedUser | null = this.getCurrentUser();
    return currentUser && currentUser.uuidPassenger
      ? currentUser.uuidPassenger
      : null;
  }

  getCurrentUser(): LoggedUser | null {
    let user: LoggedUser | null =
      this.sStorageService.getElement(CURRENT_USER) ||
      this.lStorageService.getElement(CURRENT_USER);

    if (user && user.displayName && user.user_roles && user.idToken) {
      return user;
    }

    return null;
  }

  // Returns user when is looged or null
  get user(): LoggedUser | null {
    return this.lStorageService.getElement(CURRENT_USER);
  }

  set user(user: LoggedUser | null) {
    if (user) {
      this.lStorageService.setElement(CURRENT_USER, user);
    } else {
      this.lStorageService.removeElement(CURRENT_USER);
    }
  }

  get lang(): string {
    let retrieved_lang = this.sStorageService.getElement(LANG);
    return retrieved_lang ? retrieved_lang : LANGUAGES.default;
  }

  set lang(lang: string | null) {
    if (lang) {
      this.sStorageService.addElement(lang, LANG);
    } else {
      this.sStorageService.removeElement(LANG);
    }
  }

  getCurrentUserRoles(): ROLES[] {
    let tmp: LoggedUser | null = this.getCurrentUser();
    return tmp ? tmp.user_roles : [];
  }

  isEmployee(): boolean {
    let roles: ROLES[] = this.getCurrentUserRoles();
    return (
      roles && (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.OPERATORE))
    );
  }

  isEmployeeWithoutPassenger(): boolean {
    let roles: ROLES[] = this.getCurrentUserRoles();
    return (
      roles &&
      (roles.includes(ROLES.ADMIN) || roles.includes(ROLES.OPERATORE)) &&
      !this.uuidPassenger
    );
  }

  public buildCurrentUser(
    responseLogin: any,
    localStorage: boolean = true,
    fromAdmin: boolean = false,
  ): LoggedUser | null {
    let user: LoggedUser = new LoggedUser();
    let tokenDecoded: any = jwtDecode(responseLogin.idToken);
    let roles = [];
    if(fromAdmin)
      roles = responseLogin.user_roles;
    else
      roles = tokenDecoded.role;

    let str_roles: any[] | string = [];

    if (responseLogin.displayName) {
      user.displayName = responseLogin.displayName;
    }

    if (responseLogin.displayNameImp) {
      user.displayNameImp = responseLogin.displayNameImp;
    }

    if (responseLogin.idToken) {
      user.idToken = responseLogin.idToken;
    }

    if (responseLogin.uuidPassenger) {
      user.uuidPassenger = responseLogin.uuidPassenger;
    }

    if (roles) {
      str_roles = roles;

      if (typeof str_roles === 'string') {
        let tmp: string = str_roles;
        str_roles = [tmp];
      }

      str_roles.forEach((role) => {
        let new_role = Role.get_Role(role);
        if (new_role) roles.push(new_role);
      });

      if (roles) {
        user.user_roles = roles;
      }
    }

    if (user.idToken && user.displayName && user.user_roles) {
      localStorage
        ? this.lStorageService.addElement(user, CURRENT_USER)
        : this.sStorageService.addElement(user, CURRENT_USER);
      return user;
    }

    return null;
  }

  login(body: any) {
    let url = this.api_prefix;
    return this.http.post(url, body);
  }

  logout(isExpiredToken: boolean = false) {
    this.lStorageService.clearStorage(true);
    this.sStorageService.clearStorage(true);
    sessionStorage.clear();
    console.log('Signed out!');
    if (isExpiredToken) {
      this.showError();
    } else {
      this.router.navigate([ROUTES.PRE_LANDING.path]);
    }
  }

  private showError(message?: string) {
    if (!message) message = 'confirm.session';

    const dialogRef = this.dialog.open(GenericConfirmationComponent, {
      data: {
        message: message,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      this.router.navigate([ROUTES.PRE_LANDING.path]);
    });
  }

  setLoginInfo(res: any) {
    let user: LoggedUser | null;

    user = this.getCurrentUser();
    if (!user) {
      user = this.buildCurrentUser(res);
    }

    if (!user) {
      // Should not happen, however..
      this.logout();
    }
  }

}
